import { CREATOR_CATEGORIES, PRO_CATEGORIES } from '../constants';
import * as styled from '../styles/choose-section';
import { Header } from './header';
import { HeroTrustRow } from './hero-trust-row';
import { PersonaChoiceCard } from './persona-choice-card';

type Props = {
  onSelectPro: () => void;
  onSelectCreator: () => void;
  onLogin: () => void;
  onSignUp: () => void;
};

export const ChooseSection = ({
  onSelectPro,
  onSelectCreator,
  onLogin,
  onSignUp,
}: Props) => (
  <styled.Section>
    <Header
      tone="heroDark"
      view="choose"
      onLogoClick={onSelectPro}
      onSelectPro={onSelectPro}
      onSelectCreator={onSelectCreator}
      onLogin={onLogin}
      onSignUp={onSignUp}
    />

    <styled.Main>
      <styled.Badge>
        <styled.LiveDot aria-hidden="true" />
        Free · No website needed · About 10 minutes
      </styled.Badge>

      <styled.Title>
        One link that gets you <styled.Gradient>paid work.</styled.Gradient>
      </styled.Title>

      <styled.Subtitle>
        Kudable gives you a page with your work, your prices and your reviews on
        it. Which one are you?
      </styled.Subtitle>

      <styled.CardGrid>
        <PersonaChoiceCard
          accent="pro"
          kicker="Bookings & deposits"
          title="I'm a pro"
          description="People pay me to do a job for them. I need bookings, dates and deposits."
          categories={PRO_CATEGORIES}
          onSelect={onSelectPro}
        />
        <PersonaChoiceCard
          accent="creator"
          kicker="Collabs & rate cards"
          title="I'm a content creator"
          description="Brands pay me for my content and my audience. I need collabs, sponsorships and a rate card."
          categories={CREATOR_CATEGORIES}
          onSelect={onSelectCreator}
        />
      </styled.CardGrid>

      <HeroTrustRow />
    </styled.Main>
  </styled.Section>
);
